import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import Sidebar from '../Sidebar';
import { Session } from "../utils/session";


const authHeaders = () => {
  const token = Session.getToken();
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  };
};

export default function MembersCreate() {
  const navigate = useNavigate();

  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [hideDesktop, setHideDesktop] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [roles, setRoles] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  const [form, setForm] = useState({
    userName: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNo: '',
    userRoleId: '',
    companiesId: '',
    isActive: true,
    travellingUser: false,
    password: '',
    avatarBase64: ''
  });

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setForm({
  //     ...form,
  //     [name]: type === 'checkbox' ? checked : value
  //   });
  // };

  const toggleSidebar = () => {
    if (window.innerWidth <= 991) {
      setShowMobileSidebar(s => !s);
    } else {
      setHideDesktop(s => !s);
    }
  };

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 991) {
        setShowMobileSidebar(false);
      }
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Sidebar logic - useEffect for direct DOM manipulation
  useEffect(() => {
    const overlay = document.getElementById('sidebar-overlay');
    if (overlay) {
      overlay.style.display = showMobileSidebar ? 'block' : 'none';
    }
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      if (showMobileSidebar) sidebar.classList.add('show-mobile'); else sidebar.classList.remove('show-mobile');
      if (hideDesktop) sidebar.classList.add('hide-desktop'); else sidebar.classList.remove('hide-desktop');
    }
    const content = document.getElementById('content');

    if (overlay) overlay.style.display = showMobileSidebar ? 'block' : 'none';
    if (sidebar) {
      sidebar.classList.toggle('show-mobile', showMobileSidebar);
      sidebar.classList.toggle('hide-desktop', hideDesktop);
    }
    if (content) content.classList.toggle('full-width', hideDesktop);
  }, [showMobileSidebar, hideDesktop]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'userName') {
      setErrorMessage('');
    }

    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setForm({ ...form, avatarBase64: reader.result });
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    try {
      const token = Session.getToken();
      if (!token) {
        alert('You are not logged in.');
        return;
      }

      const res = await fetch(`${API_BASE_URL}/api/Members/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(form)
      });

      if (res.ok) {
        alert('Member created successfully');
        navigate('/Members');
        return;
      }

      if (res.status === 409) {
        const data = await res.json();
        setErrorMessage(data.message || 'Username already exists');
        return;
      }

      if (res.status === 400) {
        const data = await res.json().catch(() => ({}));
        setErrorMessage(data.message || data.Message || 'Failed to create member');
        return;
      }

      const text = await res.text();
      setErrorMessage(`Failed to create member: ${text}`);
    } catch (err) {
      setErrorMessage('Failed to create member: ' + err.message);
    }
  };

  useEffect(() => {
  const loadLookups = async () => {
    try {
      const token = Session.getToken(); // get token from session
      if (!token) {
        alert('You are not logged in. Please log in.');
        return;
      }

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      };

      const [rolesRes, companiesRes] = await Promise.all([
        fetch(`${API_BASE_URL}/api/UserRole/roles`, { headers }),
        fetch(`${API_BASE_URL}/api/UserRole/companies`, { headers })
      ]);

      if (!rolesRes.ok) {
        const text = await rolesRes.text();
        throw new Error(`Roles fetch failed: ${rolesRes.status} ${text}`);
      }
      if (!companiesRes.ok) {
        const text = await companiesRes.text();
        throw new Error(`Companies fetch failed: ${companiesRes.status} ${text}`);
      }

      const rolesData = await rolesRes.json();
      const companiesData = await companiesRes.json();

      setRoles(rolesData || []);
      setCompanies(companiesData || []);
    } catch (err) {
      console.error('Lookup API error:', err);
      alert('Failed to load roles / companies: ' + err.message);
    }
  };

  loadLookups();
}, []);


  return (
    <div>
      {/* Overlay for mobile sidebar - always rendered, visibility controlled by useEffect */}
      <div id="sidebar-overlay" className="sidebar-overlay" onClick={() => setShowMobileSidebar(false)} />
      
        <Sidebar />
      
      <div id="content">
        <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
          <div className="d-flex align-items-center gap-3">
            <button
              type="button"
              id="sidebarCollapse"
              className="btn btn-toggle"
              onClick={toggleSidebar}
              aria-label="Toggle sidebar"
            >
              <i className="fas fa-bars" />
            </button>

          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-4 page-header flex-wrap gap-2">
          <h2>Member Create</h2>
        </div>
        <div className="main-card">
          <form onSubmit={handleSubmit} className="row g-3 mt-2">
            {/* Username */}
            <div className="col-md-6">
              <label className="form-label">Username</label>
              <input
                className={`form-control ${errorMessage ? 'is-invalid' : ''}`}
                name="userName"
                value={form.userName}
                onChange={handleChange}
                required
              />
              {errorMessage && (
                <div className="invalid-feedback d-block">
                  {errorMessage}
                </div>
              )}
            </div>
            {/* First Name */}
            <div className="col-md-6">
              <label className="form-label">First Name</label>
              <input className="form-control" name="firstName" value={form.firstName} onChange={handleChange} required />
            </div>
            {/* Last Name */}
            <div className="col-md-6">
              <label className="form-label">Last Name</label>
              <input className="form-control" name="lastName" value={form.lastName} onChange={handleChange} required />
            </div>
            {/* Email */}
            <div className="col-md-6">
              <label className="form-label">Email</label>
              <input className="form-control" name="email" type="email" value={form.email} onChange={handleChange} required />
            </div>
            {/* Company */}
            <div className="col-md-6">
              <label className="form-label">Company</label>
              <select className="form-select" name="companiesId" value={form.companiesId} onChange={handleChange} required>
                <option value="">Select Company</option>
                {companies.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>
            {/* Role */}
            <div className="col-md-6">
              <label className="form-label">Role</label>
              <select className="form-select" name="userRoleId" value={form.userRoleId} onChange={handleChange} required>
                <option value="">Select Role</option>
                {roles.map(r => (
                  <option key={r.id} value={r.id}>{r.name}</option>
                ))}
              </select>
            </div>
            <div className="col-md-6">
            <label className="form-label">Phone</label>
  <input
    type="tel"
    className="form-control"
    name="phoneNo"
    value={form.phoneNo}
    maxLength={10}
    pattern="[0-9]{10}"
    required
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, "");

      setForm({
        ...form,
        phoneNo: value
      });
    }}
  />
</div>
            {/* Password */}
            {/* <div className="col-md-6">
              <label className="form-label">Password</label>
              <input className="form-control" name="password" type="password" value={form.password} onChange={handleChange} required />
            </div> */}
            {/* IsActive */}
            <div className="col-md-6 d-flex align-items-end">
              <div className="form-check">
                <label className="form-check-label" htmlFor="isActive">IsActive</label>
                <input className="form-check-input" type="checkbox" name="isActive" checked={form.isActive} onChange={handleChange} id="isActive" />
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-end">
              <div className="form-check">
                <label className="form-check-label" htmlFor="travellingUser">Travelling User</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="travellingUser"
                  checked={form.travellingUser}
                  onChange={handleChange}
                  id="travellingUser"
                />
              </div>
            </div>
            {/* Profile Image */}
            <div className="col-md-6">
              <label className="form-label">Profile Image</label>
              <input type="file" className="form-control" accept="image/*" onChange={handleImage} />
            </div>
            {/* Buttons */}
            <div className="col-12 mt-3">
              <button className="btn btn-success" style={{ backgroundColor: '#0084fe', '--bs-btn-hover-bg': '#08569e' }}>Create</button>
              <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate('/Members')}>Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
